import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslation from '@/locales/en/translation.json';
import esTranslation from '@/locales/es/translation.json';
import deTranslation from '@/locales/de/translation.json';
import frTranslation from '@/locales/fr/translation.json';
import itTranslation from '@/locales/it/translation.json';
import ptTranslation from '@/locales/pt/translation.json';
import ptBRTranslation from '@/locales/pt-BR/translation.json';
import trTranslation from '@/locales/tr/translation.json';

const resources = {
  en: { translation: enTranslation },
  es: { translation: esTranslation },
  de: { translation: deTranslation },
  fr: { translation: frTranslation },
  it: { translation: itTranslation },
  pt: { translation: ptTranslation },
  'pt-BR': { translation: ptBRTranslation },
  tr: { translation: trTranslation },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'de', 'fr', 'it', 'pt', 'pt-BR', 'tr'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ui-language',
    },
  });

export default i18n;
